<template>
  <div id="cat" v-cloak>
    <loading v-if="showLoading"></loading>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row flex gap-y-2 justify-between px-4">
            <div class="flex-grow">
              <vs-button
                @click="insertPrice()"
                class="bg_l_green"
                v-has-permission="permission27"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Pricing") }}
              </vs-button>
            </div>
            <div class="flex flex-grow gap-2 justify-end">
              <div class="flex">
                <label class="custom-file-upload">
                  <input
                    type="file"
                    id="file"
                    ref="file"
                    v-on:change="handleFileUpload()"
                  />

                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("ChooseFile") }}
                  <span v-if="uploadedFileName" class="file-name">{{
                    uploadedFileName
                  }}</span>
                </label>
                <vs-button
                  @click="uploadFile()"
                  class="bg_m_green float-right"
                  v-if="fileUploaded"
                  :disabled="disabledBtn"
                  v-has-permission="permission25"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("UploadFile") }}
                </vs-button>
              </div>
              <vs-button
                @click="downloadFile()"
                class="bg_purple float-right"
                v-has-permission="permission26"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("DownloadFile") }}
              </vs-button>
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
              >
                <div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
          <div class="vx-row" v-if="showFilters">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full mt-1">
                    <div class="w-full">
                      <vs-input
                        class="inputx mb-4 mt-1"
                        v-model="gridSearchData.Name"
                        :label="$t('ProductName')"
                      />
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-1">
                    <div class="w-full">
                      <vs-input
                        class="inputx mb-4"
                        v-model="gridSearchData.ItemCode"
                        :label="$t('ItemCode')"
                      />
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-1">
                    <label class="vs-input--label">{{
                      $t("ToleranceType")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="title"
                        :options="toleranceTypes"
                        v-model="gridSearchData.ToleranceType"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("FromDate")
                    }}</label>
                    <date-picker
                      v-model="gridSearchData.MinCreateTime"
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      :label="$t('FromDate')"
                      :clearable="true"
                    />
                  </div>
                  <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("ToDate")
                    }}</label>
                    <date-picker
                      v-model="gridSearchData.MaxCreateTime"
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      :label="$t('ToDate')"
                      :clearable="true"
                    />
                  </div>
                </div>

                <div class="vx-row pt-4">
                  <div class="vx-col w-full">
                    <vs-button
                      type="filled"
                      class="float-right"
                      @click.prevent="submitFilter()"
                      v-has-permission="permission24"
                      >{{ $t("SubmitFilter") }}</vs-button
                    >
                    <vs-button
                      type="filled"
                      class="float-right ml-4"
                      id="reset-btn"
                      @click.prevent="resetForm"
                      >{{ $t("ResetFilter") }}</vs-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="vx-row pt-4">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('ProductName'), sort: 'ProductName' },
                  { title: $t('ItemCode'), sort: 'ItemCode' },
                  { title: $t('BasePrice'), sort: 'BasePrice' },
                  { title: $t('ToleranceType'), sort: 'ToleranceType' },
                  { title: $t('AllowedReduction'), sort: 'AllowedReduction' },
                  { title: $t('PriceFloor') },
                  { title: $t('AllowedIncrease'), sort: 'AllowedIncrease' },
                  { title: $t('PriceCeiling') },
                  { title: $t('CreateOn'), sort: 'CreateOn' },
                  { title: $t('Action') },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 25%">
                    {{ row.productInfo.name }}
                  </td>
                  <td style="width: 8%">
                    {{ row.productInfo.itemCode }}
                  </td>
                  <td style="width: 10%">
                    {{ Number(row.basePrice).toLocaleString() }} ریال
                  </td>
                  <td style="width: 7%">
                    <span v-if="row.toleranceType === 'Amount'">مقداری</span>
                    <span v-else-if="row.toleranceType === 'Percent'"
                      >درصدی</span
                    >
                  </td>
                  <td style="width: 9%">
                    <span v-if="row.toleranceType === 'Amount'">
                      {{ Number(row.allowedReduction).toLocaleString() }} ریال
                    </span>
                    <span v-else> %{{ row.allowedReduction }} </span>
                  </td>
                  <td style="width: 10%">
                    {{ Number(row.boundary.priceFloor).toLocaleString() }} ریال
                  </td>
                  <td style="width: 9%">
                    <span v-if="row.toleranceType === 'Amount'">
                      {{ Number(row.allowedIncrease).toLocaleString() }} ریال
                    </span>
                    <span v-else> %{{ row.allowedIncrease }} </span>
                  </td>
                  <td style="width: 10%">
                    {{ Number(row.boundary.priceCeiling).toLocaleString() }}
                    ریال
                  </td>
                  <td style="width: 7%">
                    {{ row.createOn.split(" ")[0] }}<br />{{
                      row.createOn.split(" ")[1]
                    }}
                  </td>
                  <td style="width: 5%">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      @click.prevent="editPrice(row)"
                      class="mx-auto d-inline"
                      v-has-permission="permission28"
                    ></vs-button>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
          <modify-popup
            :show="showModifyPopup"
            :model="modalModel"
            @finish="onfinish"
            @close="closeModifyPopup"
          ></modify-popup>
          <create-popup
            :show="showCreatePopup"
            :model="modalModel"
            @finish="onfinish"
            @close="closeCreatePopup"
          ></create-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
import CreatePopup from "./CreatePopup.vue";
import vSelect from "vue-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  name: "saleManagement_Priceing_Index",
  components: {
    ModifyPopup,
    CreatePopup,
    DataGrid,
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      permission24: "",
      permission25: "",
      permission26: "",
      permission27: "",
      permission28: "",
      showFilters: false,
      showModifyPopup: false,
      showCreatePopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Sales/api/PricesQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      toleranceTypes: [
        { id: 1, title: "درصدی" },
        { id: 2, title: "مقداری" },
      ],
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      showLoading: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
  },

  methods: {
    ...mapActions({
      importPricingExcel: "excel/importPrices",
      exportPricingExcel: "excel/exportPricesQuery",
    }),
    ////Open Modal In Create Mode
    insertPrice() {
      this.modalModel = {};
      this.showCreatePopup = true;
    },
    //Open Modal In Edit Mode
    editPrice(model) {
      this.modalModel = {
        id: model.id,
        itemCode: model.productInfo.itemCode,
        basePrice: model.basePrice,
        toleranceType: model.toleranceType,
        allowedReduction: model.allowedReduction,
        allowedIncrease: model.allowedIncrease,
      };
      this.showModifyPopup = true;
    },
    closeModifyPopup() {
      this.showModifyPopup = false;
    },
    closeCreatePopup() {
      this.showCreatePopup = false;
    },
    onfinish() {
      this.closeCreatePopup;
      this.closeModifyPopup;
      this.$refs.grid.renderGrid();
    },

    downloadFile() {
      this.exportPricingExcel();
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.showLoading = true;
      this.importPricingExcel(formData).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "فایل مورد نظر با موفقیت بارگذاری شد!",
          showConfirmButton: false,
          timer: 5000,
        });
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.updateLoading = false;
        this.disabledBtn = false;
      }, 1000);
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        PartyName: "",
        PartyType: "",
        ContractId: "",
        MinAmount: "",
        MaxAmount: "",
        MinCreateTime: "",
        MaxCreateTime: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
